import * as Types from './operations.js';

import { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-tag';
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
export const CollectionDataFieldsFragmentDoc = gql`
    fragment CollectionDataFields on current_collections_v2 {
  uri
  max_supply
  description
  collection_name
  collection_id
  creator_address
  cdn_asset_uris {
    cdn_image_uri
  }
}
    `;
export const TokenDataFieldsFragmentDoc = gql`
    fragment TokenDataFields on current_token_datas_v2 {
  current_collection {
    ...CollectionDataFields
  }
  cdn_asset_uris {
    cdn_image_uri
  }
  last_transaction_timestamp
  last_transaction_version
  token_properties
  token_standard
  is_fungible_v2
  token_data_id
  description
  token_name
  token_uri
}
    ${CollectionDataFieldsFragmentDoc}`;
export const TokenOwnershipFieldsFragmentDoc = gql`
    fragment TokenOwnershipFields on current_token_ownerships_v2 {
  current_token_data {
    ...TokenDataFields
  }
  is_soulbound_v2
  owner_address
  amount
}
    ${TokenDataFieldsFragmentDoc}`;
export const CollectionOwnershipFragmentDoc = gql`
    fragment CollectionOwnership on current_collection_ownership_v2_view {
  distinct_tokens
  single_token_uri
  current_collection {
    ...CollectionDataFields
  }
}
    ${CollectionDataFieldsFragmentDoc}`;
export const PrimaryAptosNameFragmentDoc = gql`
    fragment PrimaryAptosName on current_aptos_names {
  domain
  subdomain
}
    `;
export const FungibleAssetMetadataFieldsFragmentDoc = gql`
    fragment FungibleAssetMetadataFields on fungible_asset_metadata {
  asset_type
  creator_address
  decimals
  icon_uri
  project_uri
  name
  symbol
  token_standard
  supply_v2
  maximum_v2
}
    `;
export const FungibleAssetActivityFragmentDoc = gql`
    fragment FungibleAssetActivity on fungible_asset_activities {
  owner_primary_aptos_name: owner_aptos_names(
    where: {is_primary: {_eq: true}, is_active: {_eq: true}}
  ) {
    ...PrimaryAptosName
  }
  type
  amount
  block_height
  asset_type
  metadata {
    ...FungibleAssetMetadataFields
  }
  entry_function_id_str
  owner_address
  event_index
  is_gas_fee
  gas_fee_payer_address
  is_transaction_success
  transaction_timestamp
  transaction_version
}
    ${PrimaryAptosNameFragmentDoc}
${FungibleAssetMetadataFieldsFragmentDoc}`;
export const BaseTokenActivityFragmentDoc = gql`
    fragment BaseTokenActivity on token_activities_v2 {
  from_address
  to_address
  transaction_version
  transaction_timestamp
  type
  event_account_address
  event_index
}
    `;
export const TokenActivityFragmentDoc = gql`
    fragment TokenActivity on token_activities_v2 {
  ...BaseTokenActivity
  primary_aptos_name_from: aptos_names_from(
    where: {is_primary: {_eq: true}, is_active: {_eq: true}}
  ) {
    domain
    subdomain
  }
  primary_aptos_name_to: aptos_names_to(
    where: {is_primary: {_eq: true}, is_active: {_eq: true}}
  ) {
    domain
    subdomain
  }
  token_amount
  current_token_data {
    ...TokenDataFields
  }
  property_version_v1
  token_amount
  token_data_id
}
    ${BaseTokenActivityFragmentDoc}
${TokenDataFieldsFragmentDoc}`;
export const DelegatedStakingActivityFragmentDoc = gql`
    fragment DelegatedStakingActivity on delegated_staking_activities {
  amount
  delegator_address
  event_index
  event_type
  pool_address
  transaction_version
}
    `;
export const UserTransactionFragmentDoc = gql`
    fragment UserTransaction on user_transactions {
  sequence_number
  sender
  entry_function_id_str
  expiration_timestamp_secs
  gas_unit_price
  max_gas_amount
  parent_signature_type
  version
  timestamp
}
    `;
export const AccountTransactionFragmentDoc = gql`
    fragment AccountTransaction on account_transactions {
  account_address
  transaction_version
  fungible_asset_activities(
    where: {asset_type: {_is_null: false}, _and: $fungible_asset_activities_where}
    order_by: $fungible_asset_activities_order_by
  ) {
    ...FungibleAssetActivity
  }
  token_activities_v2(
    where: {_and: $token_activities_v2_where}
    order_by: $token_activities_v2_order_by
  ) {
    ...TokenActivity
  }
  delegated_staking_activities(order_by: {event_index: desc}) {
    ...DelegatedStakingActivity
  }
  user_transaction {
    ...UserTransaction
  }
}
    ${FungibleAssetActivityFragmentDoc}
${TokenActivityFragmentDoc}
${DelegatedStakingActivityFragmentDoc}
${UserTransactionFragmentDoc}`;
export const FungibleAssetBalanceFieldsFragmentDoc = gql`
    fragment FungibleAssetBalanceFields on current_fungible_asset_balances {
  amount
  amount_v1
  amount_v2
  asset_type
  asset_type_v1
  asset_type_v2
  is_frozen
  is_primary
  last_transaction_timestamp
  last_transaction_version
  token_standard
  owner_address
  metadata {
    ...FungibleAssetMetadataFields
  }
}
    ${FungibleAssetMetadataFieldsFragmentDoc}`;
export const GetAccountTokensTotalDocument = gql`
    query getAccountTokensTotal($address: String!, $where: [current_token_ownerships_v2_bool_exp!]!) {
  current_token_ownerships_v2_aggregate(
    where: {owner_address: {_eq: $address}, amount: {_gt: 0}, _and: $where}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const GetAccountTokenOwnershipsDocument = gql`
    query getAccountTokenOwnerships($address: String!, $offset: Int, $limit: Int, $where: [current_token_ownerships_v2_bool_exp!]!, $order_by: [current_token_ownerships_v2_order_by!]!) {
  current_token_ownerships_v2(
    where: {owner_address: {_eq: $address}, amount: {_gt: 0}, current_token_data: {token_data_id: {_is_null: false}}, _and: $where}
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    ...TokenOwnershipFields
  }
}
    ${TokenOwnershipFieldsFragmentDoc}`;
export const GetCurrentTokenDataDocument = gql`
    query getCurrentTokenData($tokenId: String!, $address: String!) {
  current_token_datas_v2(where: {token_data_id: {_eq: $tokenId}}) {
    token_name
    current_collection {
      collection_name
    }
    last_transaction_timestamp
    description
    token_properties
    token_uri
    cdn_asset_uris {
      cdn_image_uri
    }
  }
  created_activity: token_activities_v2(
    where: {token_data_id: {_eq: $tokenId}}
    order_by: [{transaction_version: asc}, {event_index: asc}]
    limit: 1
  ) {
    from_address
    to_address
    transaction_timestamp
    type
    transaction_version
    event_index
    event_account_address
  }
  acquired_activity: token_activities_v2(
    where: {token_data_id: {_eq: $tokenId}, to_address: {_eq: $address}}
    order_by: [{transaction_version: desc}, {event_index: desc}]
    limit: 1
  ) {
    from_address
    to_address
    transaction_timestamp
    type
    transaction_version
    event_index
  }
}
    `;
export const GetAccountCollectionsDocument = gql`
    query getAccountCollections($address: String!, $offset: Int, $limit: Int, $where: [current_collection_ownership_v2_view_bool_exp!]!, $order_by: [current_collection_ownership_v2_view_order_by!]!) {
  current_collection_ownership_v2_view(
    where: {owner_address: {_eq: $address}, _and: $where}
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    ...CollectionOwnership
  }
}
    ${CollectionOwnershipFragmentDoc}`;
export const GetTokenDataDocument = gql`
    query getTokenData($address: String!) {
  current_token_datas_v2(where: {token_data_id: {_eq: $address}}) {
    ...TokenDataFields
  }
  created_activity: token_activities_v2(
    where: {token_data_id: {_eq: $address}}
    order_by: [{transaction_version: asc}, {event_index: asc}]
    limit: 1
  ) {
    from_address
    to_address
    transaction_timestamp
    type
    transaction_version
    event_index
    event_account_address
  }
  acquired_activity: token_activities_v2(
    where: {token_data_id: {_eq: $address}}
    order_by: [{transaction_version: desc}, {event_index: desc}]
    limit: 1
  ) {
    from_address
    to_address
    transaction_timestamp
    type
    transaction_version
    event_index
    event_account_address
  }
}
    ${TokenDataFieldsFragmentDoc}`;
export const GetActivitiesAggregateDocument = gql`
    query getActivitiesAggregate($account_address: String!) {
  address_events_summary(where: {account_address: {_eq: $account_address}}) {
    block_metadata {
      timestamp
    }
    num_distinct_versions
  }
}
    `;
export const GetTokenActivitiesDocument = gql`
    query getTokenActivities($tokenId: String!, $offset: Int, $limit: Int) {
  token_activities_v2(
    where: {token_data_id: {_eq: $tokenId}}
    order_by: [{transaction_timestamp: desc}, {transaction_version: desc}]
    offset: $offset
    limit: $limit
  ) {
    ...TokenActivity
  }
}
    ${TokenActivityFragmentDoc}`;
export const GetTokenAcquisitionActivityDocument = gql`
    query getTokenAcquisitionActivity($address: String!, $tokenId: String!) {
  token_activities_v2(
    where: {token_data_id: {_eq: $tokenId}, to_address: {_eq: $address}}
    order_by: [{transaction_timestamp: desc}, {transaction_version: desc}]
  ) {
    transaction_timestamp
  }
}
    `;
export const GetAccountTransactionsDocument = gql`
    query getAccountTransactions($address: String!, $limit: Int, $offset: Int, $where: [account_transactions_bool_exp!]!, $fungible_asset_activities_where: [fungible_asset_activities_bool_exp!]!, $token_activities_v2_where: [token_activities_v2_bool_exp!]!, $order_by: [account_transactions_order_by!]!, $fungible_asset_activities_order_by: [fungible_asset_activities_order_by!]!, $token_activities_v2_order_by: [token_activities_v2_order_by!]!) {
  account_transactions(
    limit: $limit
    offset: $offset
    where: {account_address: {_eq: $address}, _and: $where}
    order_by: $order_by
  ) {
    ...AccountTransaction
  }
}
    ${AccountTransactionFragmentDoc}`;
export const GetUserTransactionsDocument = gql`
    query getUserTransactions($limit: Int, $offset: Int, $where: user_transactions_bool_exp, $order_by: [user_transactions_order_by!]!) {
  user_transactions(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...UserTransaction
  }
}
    ${UserTransactionFragmentDoc}`;
export const GetAccountTotalTransactionsDocument = gql`
    query getAccountTotalTransactions($address: String!) {
  move_resources_aggregate(where: {address: {_eq: $address}}) {
    aggregate {
      count
    }
  }
}
    `;
export const GetFungibleAssetMetadataDocument = gql`
    query getFungibleAssetMetadata($type: String!) {
  fungible_asset_metadata(where: {asset_type: {_eq: $type}}) {
    asset_type
    decimals
    name
    symbol
  }
}
    `;
export const GetFungibleAssetBalancesDocument = gql`
    query getFungibleAssetBalances($where: current_fungible_asset_balances_bool_exp, $order_by: [current_fungible_asset_balances_order_by!], $offset: Int, $limit: Int) {
  current_fungible_asset_balances(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...FungibleAssetBalanceFields
  }
}
    ${FungibleAssetBalanceFieldsFragmentDoc}`;
export const GetDelegatedStakingRoyaltiesDocument = gql`
    query getDelegatedStakingRoyalties($address: String!, $pool: String) {
  delegated_staking_activities(
    where: {delegator_address: {_eq: $address}, pool_address: {_eq: $pool}}
    order_by: {transaction_version: desc}
  ) {
    amount
    delegator_address
    event_index
    event_type
    pool_address
    transaction_version
  }
}
    `;
export const GetDelegatedStakingDocument = gql`
    query getDelegatedStaking($address: String!) {
  delegator_distinct_pool(where: {delegator_address: {_eq: $address}}) {
    delegator_address
    pool_address
    current_pool_balance {
      operator_commission_percentage
    }
    staking_pool_metadata {
      operator_address
      operator_aptos_name {
        domain
      }
    }
  }
}
    `;
export const GetDelegationPoolsDocument = gql`
    query getDelegationPools {
  delegated_staking_pools {
    staking_pool_address
    current_staking_pool {
      operator_address
    }
  }
}
    `;
export const GetNumberOfDelegatorsDocument = gql`
    query getNumberOfDelegators($poolAddress: String) {
  num_active_delegator_per_pool(
    where: {pool_address: {_eq: $poolAddress}, num_active_delegator: {_gt: "0"}}
    distinct_on: pool_address
  ) {
    num_active_delegator
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getAccountTokensTotal(variables: Types.GetAccountTokensTotalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetAccountTokensTotalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetAccountTokensTotalQuery>({ document: GetAccountTokensTotalDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getAccountTokensTotal', 'query', variables);
    },
    getAccountTokenOwnerships(variables: Types.GetAccountTokenOwnershipsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetAccountTokenOwnershipsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetAccountTokenOwnershipsQuery>({ document: GetAccountTokenOwnershipsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getAccountTokenOwnerships', 'query', variables);
    },
    getCurrentTokenData(variables: Types.GetCurrentTokenDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetCurrentTokenDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetCurrentTokenDataQuery>({ document: GetCurrentTokenDataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getCurrentTokenData', 'query', variables);
    },
    getAccountCollections(variables: Types.GetAccountCollectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetAccountCollectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetAccountCollectionsQuery>({ document: GetAccountCollectionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getAccountCollections', 'query', variables);
    },
    getTokenData(variables: Types.GetTokenDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetTokenDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetTokenDataQuery>({ document: GetTokenDataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getTokenData', 'query', variables);
    },
    getActivitiesAggregate(variables: Types.GetActivitiesAggregateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetActivitiesAggregateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetActivitiesAggregateQuery>({ document: GetActivitiesAggregateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getActivitiesAggregate', 'query', variables);
    },
    getTokenActivities(variables: Types.GetTokenActivitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetTokenActivitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetTokenActivitiesQuery>({ document: GetTokenActivitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getTokenActivities', 'query', variables);
    },
    getTokenAcquisitionActivity(variables: Types.GetTokenAcquisitionActivityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetTokenAcquisitionActivityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetTokenAcquisitionActivityQuery>({ document: GetTokenAcquisitionActivityDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getTokenAcquisitionActivity', 'query', variables);
    },
    getAccountTransactions(variables: Types.GetAccountTransactionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetAccountTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetAccountTransactionsQuery>({ document: GetAccountTransactionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getAccountTransactions', 'query', variables);
    },
    getUserTransactions(variables: Types.GetUserTransactionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetUserTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetUserTransactionsQuery>({ document: GetUserTransactionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getUserTransactions', 'query', variables);
    },
    getAccountTotalTransactions(variables: Types.GetAccountTotalTransactionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetAccountTotalTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetAccountTotalTransactionsQuery>({ document: GetAccountTotalTransactionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getAccountTotalTransactions', 'query', variables);
    },
    getFungibleAssetMetadata(variables: Types.GetFungibleAssetMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetFungibleAssetMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetFungibleAssetMetadataQuery>({ document: GetFungibleAssetMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getFungibleAssetMetadata', 'query', variables);
    },
    getFungibleAssetBalances(variables?: Types.GetFungibleAssetBalancesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetFungibleAssetBalancesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetFungibleAssetBalancesQuery>({ document: GetFungibleAssetBalancesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getFungibleAssetBalances', 'query', variables);
    },
    getDelegatedStakingRoyalties(variables: Types.GetDelegatedStakingRoyaltiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetDelegatedStakingRoyaltiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetDelegatedStakingRoyaltiesQuery>({ document: GetDelegatedStakingRoyaltiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDelegatedStakingRoyalties', 'query', variables);
    },
    getDelegatedStaking(variables: Types.GetDelegatedStakingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetDelegatedStakingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetDelegatedStakingQuery>({ document: GetDelegatedStakingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDelegatedStaking', 'query', variables);
    },
    getDelegationPools(variables?: Types.GetDelegationPoolsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetDelegationPoolsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetDelegationPoolsQuery>({ document: GetDelegationPoolsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDelegationPools', 'query', variables);
    },
    getNumberOfDelegators(variables?: Types.GetNumberOfDelegatorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.GetNumberOfDelegatorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GetNumberOfDelegatorsQuery>({ document: GetNumberOfDelegatorsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getNumberOfDelegators', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;